import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReservationService } from '../../..';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { first } from 'rxjs';
import { MessageService } from 'primeng/api';
import {Location} from '@angular/common';

@Component({
    selector: 'app-reservation-container',
    templateUrl: './reservation-container.component.html',
    styleUrls: ['./reservation-container.component.css'],
    standalone: false
})
export class ReservationContainerComponent implements OnInit {

  // form
	formLoading = false;
	reservation: any;
	reservationId: any;

	// nav
	tabIndex: number;
    numAdults: any[];
	workOrders: any;
    lostFounds: any;

	//boolean
	showCloseButton = false; //Show close button on dialog
    shortTermRentalId: any;
    propertyCode: any;
	formTitle: any;

	constructor(
		private reservationService: ReservationService,
		private messageService: MessageService,
		private location1: Location,
		private activatedRoute: ActivatedRoute,
		@Inject(MAT_DIALOG_DATA) data: any) {
			this.formTitle = data.title;
			this.reservation = data.reservation;
			this.reservationId = data.reservationId;
			// this.shortTermRentalId = this.reservation?.shortTermRental?.shortTermRentalId;
			// this.propertyCode = this.reservation?.shortTermRental?.propertyCode;
			this.showCloseButton = data.showCloseButton ? true : false;
			this.numAdults =  this.reservationService.numAdults;
		 }

	ngOnInit(): void {
		// When opened via route URL (not as a Material dialog), MAT_DIALOG_DATA defaults
		// to an empty array and provides no reservationId.  Fall back to the route param.
		if (!this.reservationId) {
			const routeId = this.activatedRoute.snapshot.paramMap.get('reservationId');
			if (routeId) {
				this.reservationId = +routeId;
			}
		}
		this.findReservationById(this.reservationId);
		console.log("this.reservation : "+JSON.stringify(this.reservation))
	}

	findReservationById(reservationId: number) {
		this.formLoading = true;
		this.reservationService.findById(reservationId)
			.pipe(first())
			.subscribe(
				res => {
					console.log('findReservationById: ' + JSON.stringify(res));
					this.reservation = res.data.reservation;
					this.reservationId = this.reservation.reservationId;
					this.shortTermRentalId = this.reservation?.shortTermRental?.shortTermRentalId;
					this.propertyCode = this.reservation?.shortTermRental?.propertyCode;
				},
				err => {
					console.log('error In findReservationById is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + (err?.error?.error || err?.error?.message || err?.message || err || 'Unknown error'), sticky: true });
				},
				() => { this.formLoading = false; });
	}

	closePopUp(){
		this.location1.go('/reservations');
	}

}
